<template>
	<div id="page_2">
		<div class="title">
			<p>产品智能化进阶</p>
			<p class="sub">每个版本都是一个弹性方案都可无缝升级，从智能控制到运营规划，Qiot方案全线满足</p>
		</div>
		<div class="card-group">
			<template v-for="(item,index) in aCardGroup">
				<div class="jiantou"  v-if="index != 0" >
					<img :src="img.jiantou" />
				</div>
				<div class="card">
					<img :src="item.img" @mouseover="fnImageHover(item,index)" @mouseout="fnImageHover(item,index)" />
				</div>
			</template>
		</div>	
		
		<div class="desc">
			<h4>{{sDesc.name}}</h4>
			<div>{{sDesc.desc}}</div>
			<el-button type="primary" @click="fnToRouter('/404')">查看详情</el-button>
		</div>
		</transition>
	</div>
</template>
<script>	
	export default {
		data() {
			return {
				iCardIndex:0,
				img:{
					jiantou:require("@/assets/img/home/jiantou.png")
				},
				aCardGroup:[
					{
						"name":"公云通用版",
						"img":require("@/assets/img/home/2_1.png"),
						"img_hover":require("@/assets/img/home/2_1_hover.png"),
						"desc":"无需顾虑成本、开发速度、开发沟通等因素，Qiot免费使用，上手即可实现：定义协议生成控制通讯APP"
					},
					{
						"name":"公云UI制定版",
						"img":require("@/assets/img/home/2_2.png"),
						"img_hover":require("@/assets/img/home/2_2_hover.png"),
						"desc":"无需开发，只需要UI设计师，即可完成个性化定制。基于通用版为您制定产品专属页面。"
					},
					{
						"name":"公云品牌制定版",
						"img":require("@/assets/img/home/2_3.png"),
						"img_hover":require("@/assets/img/home/2_3_hover.png"),
						"desc":"品牌专属APP在这里无需开发，基于Qiot定制成您的品牌专属APP，拥有个性化UI界面。"
					},
					{
						"name":"私云运营级版",
						"img":require("@/assets/img/home/2_4.png"),
						"img_hover":require("@/assets/img/home/2_4_hover.png"),
						"desc":"与公云服务器功能一致，含手机端Qiot通用版及PC端管理后台所有功能。私云独立运作，独立数据存储。"
					}
				]
			}
		},
		computed: {
			"sDesc":function(){
				return this.aCardGroup[this.iCardIndex];
			}
		},
		methods: {
			"fnImageHover":function(item,i){
				var temp = item.img;
				item.img = item.img_hover;
				item.img_hover = temp;
				this.iCardIndex = i;
			},
		},
		components: {			
		},
		created() {
		}
	}
</script>
<style lang="less">
	@import url("../../assets/common.less");
	#page_2{
		.page();
		& > .title{
			.page_title();
		}
		& > .card-group{
			overflow: hidden;
			position: absolute;
			top: 40vh;
			bottom: auto;
			left: 0;
			right: 0;
			margin: 0 10vw;
			& > .jiantou{
					position: relative;
					float: left;
					width: 25% / 3;
					height: calc(~"80vw *0.8 * 0.7 / 4");
					vertical-align: bottom;
				img{
					position: absolute;
					width: 100%;
					top: 0;
					bottom: 0;
					margin: auto;
				}
			}
			& > .card{
				float: left;
				width: 70%/4;
				text-align: center;
				& > img{
					width: 80%;
					height: auto;
				}
			}
			@media (max-width: 1080px){
				&{
					& > .jiantou{
						display: none;
					}
					& > .card{
						width: 25%;
						& > img{
							width: 80%;
							height: auto;
							max-width: 230px;
						}
					}	
				}
			}
			@media (max-width: 768px){
				&{
					top: 35vh;
					& > .jiantou{
						display: none;
					}
					& > .card{
						width: 50%;
						& > img{
							width: 40vw;
							height: auto;
							max-width: 230px;
						}
					}	
				}
			}
		}
		& > .desc{
			position: absolute;
			bottom: 10vh;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 30vw;			
			text-align: center;
			@media (max-width: 768px){
				&{
					display: none;
				}
			}
			h4{
				.h4();
				padding-bottom: 1em;
			}
			& > div{
			}
			& > .el-button{
				margin: 30px;
				color:#FFF;
				@media (max-height: 700px){
					& {
						margin:10px;
					}
				}
			}
			
		}
	}
</style>


// WEBPACK FOOTER //
// page_2.vue?885b4e96